import React from "react";
import "./styles.scss";
import { Table } from "@mantine/core";
import { ICarbonFootprintDetailsData } from "../../../api/Shipment.CarbonFootprintDetails/Shipment.CarbonFootprintDetails.types";

interface Props {
  carbonFootprints: ICarbonFootprintDetailsData[]
}

function CarbonFootprintDetails(props: Props) {
  const { carbonFootprints } = props;
  const rows = carbonFootprints.map((carbonFootprint) => {
    const { container_number, est_carbon_footprint, act_carbon_footprint, realized_carbon_footprint, confidence_level } = carbonFootprint;

    return (
      <tr key={container_number}>
        <td>{container_number}</td>
        <td>{est_carbon_footprint}</td>
        <td>{act_carbon_footprint}</td>
        <td>{realized_carbon_footprint}</td>
        <td>{confidence_level}</td>
      </tr>
    )
  });

  return (
    <Table className="cabon-footprint-details" striped>
      <thead>
        <tr>
          <th>Container #</th>
          <th>Est. Carbon Footprint <small>(WTW Kg CO2)</small></th>
          <th>Act. Carbon Footprint <small>(WTW Kg CO2)</small></th>
          <th>Realized Carbon Footprint <small>(WTW Kg CO2)</small></th>
          <th>Confidence Level <small>(%)</small></th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  )
}

export default CarbonFootprintDetails;